export const bootstrappedData = ((globalThis as any).window as Window)?.BOOTSTRAPPED_DATA ?? {};

/**
 * Whether Rails serves this account the React subscription page (`Account#react_subscription_page?`).
 * Read from the bootstrap, not the account's features: an expired account's features are empty.
 */
export const getHasReactSubscriptionPage = (): boolean =>
  bootstrappedData.react_subscription_page === true;
